export const Language = {
  EN: 'EN',
  FR: 'FR'
};
